<span class="col1"> {{ 'label.date' | translate }}</span>
<span class="col1">{{ 'label.day' | translate }}</span>
<span class="col1">{{ 'label.status' | translate }}</span>
<span class="col1">{{ 'label.dailyScans' | translate }}</span>
<ng-container *ngIf="isDGA$ | async">
  <span class="col1">{{ 'label.arcings' | translate }}</span>
  <span class="col1">{{ 'label.xraErrors' | translate }}</span>
</ng-container>

<span class="firstDate">{{
  (firstDate$ | async)?.logDay | localizedDate
}}</span>
<span class="lastDate">
  {{ (lastDate$ | async)?.logDay | localizedDate }}
</span>
<ng-container *ngFor="let tubeHistory of tubeHistories$ | async; index as i">
  <span class="day" [ngStyle]="{ 'grid-column': i + 2, 'grid-row': 2 }">{{
    tubeHistory.logDay | date: 'EEE'
  }}</span>
  <span
    class="day-mobile"
    [ngStyle]="{ 'grid-column': i + 2, 'grid-row': 2 }"
    >{{ tubeHistory.logDay | date: 'EEEEE' }}</span
  >

  <!-- icon="{{ tubeHistory.stateIcon }}" -->
  <sh-icon
    color="secondary"
    [class]="(isDGA$ | async) ? 'sh-icon-dga icon' : 'icon'"
    [ngStyle]="{ 'grid-column': i + 2, 'grid-row': 3 }"
    size="s"
    icon="success"
    [attr.color]="
      tubeHistory.stateIconColor ? tubeHistory.stateIconColor : null
    "
  >
  </sh-icon>
  <span
    class="counter mg-t-5"
    [ngStyle]="{ 'grid-column': i + 2, 'grid-row': 4 }"
    >{{ tubeHistory.dailyScanCounter }}</span
  >
  <ng-container *ngIf="isDGA$ | async">
    <span [ngStyle]="{ 'grid-column': i + 2, 'grid-row': 5 }">{{
      tubeHistory.arcingsAlarms.hitCounterOrMarkerId
    }}</span>
    <span [ngStyle]="{ 'grid-column': i + 2, 'grid-row': 6 }">{{
      tubeHistory.xraErrorAlarms.hitCounterOrMarkerId
    }}</span>
  </ng-container>
</ng-container>
